import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['hotline'];
  static classes = ["hide"];

  viewHotline(event){
    event.preventDefault();
    this.hotlineTarget.classList.toggle(this.hideClass);
  }

}
